import * as React from "react";

function SvgCourier(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="30 25 120 120"
      {...{ ...props, ref }}
    >
      <defs>
        <clipPath id="Courier_svg__a">
          <path d="M0 0h505v160H0z" />
        </clipPath>
      </defs>
      <g data-name="Artboard \u2013 2" clipPath="url(#Courier_svg__a)">
        <g
          data-name="Group 4454"
          transform="translate(36.448 32.198)"
          fill="#9d348b"
        >
          <path
            data-name="Subtraction 88"
            d="M53.151 106.339A53.16 53.16 0 012.937 35.725a52.883 52.883 0 018.146-15.026 23.783 23.783 0 016.691 4.449 25.805 25.805 0 014.309 5.322 28.047 28.047 0 013.328 8.015 31.422 31.422 0 0054.4 31.381h23.866a53.094 53.094 0 01-50.526 36.473zm50.505-69.8H79.791a31.341 31.341 0 00-24.766-14.7 40.68 40.68 0 00-8.069-6.8 33.747 33.747 0 00-7.169-3.521 26.729 26.729 0 00-8.754-1.54 25.5 25.5 0 00-6.493.851 29.676 29.676 0 00-6.925 2.846 53.135 53.135 0 0185.106 20.209c.342.874.662 1.752.955 2.643z"
          />
          <path
            data-name="Path 39"
            d="M90.976 32.941c1.162.094 3.652-.653 12.55 3.463 2.283 8.866-17.278 12.4-23.843 0a22.977 22.977 0 0111.293-3.463z"
          />
          <path
            data-name="Path 40"
            d="M90.976 73.252c1.162-.095 3.787.653 12.667-3.458 2.279-8.871-17.327-12.405-23.866 0a22.715 22.715 0 0011.199 3.458z"
          />
          <circle
            data-name="Ellipse 156"
            cx={2.702}
            cy={2.702}
            transform="translate(31.087 15.83)"
            r={2.702}
          />
          <path
            data-name="Subtraction 76"
            d="M62.936 68.065a32.336 32.336 0 01-31.732-26.059 54.935 54.935 0 0038.527 25.347 32.829 32.829 0 01-6.795.712z"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgCourier);
